<template>
  <div>
    <div class="row px-2">
      <div
        class="col-12 rounded"
        :style="`background: ${backgroundColor}; border: ${border}`"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalendarEvent',
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    backgroundColor: {
      type: String,
      default: () => '#ffecdf',
    },
    borderColor: {
      type: String,
      default: () => '#f16a50',
    },
  },
  computed: {
    border() {
      return `1px solid ${this.borderColor}`;
    },
  },
};
</script>
<style lang="scss"></style>
